require('slick-carousel');
require('bootstrap-datepicker');
require('choices.js');
jQuery.fn.exists = function () { return this.length > 0; };

(($) => {

  if ($('#featured-merchants').length) {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: '/ajax/featuredMerchants',
      success: function (data) {
        $('#featured-merchants').html(data);
        $('#merchants-carousel')
          .slick({
            arrows: false,
            variableWidth: true,
            dots: true,
          });
      },
      error: function (error) {
        console.log('Error ocured: ', error);
      }
    });
  }

  $('#products-carousel').slick({
    arrow: false,
    variableWidth: true,
    dots: true,
  });

  const userProfileDateFields = ['#recommendation-info_dl-expiration'];
  const datepickerOptions = {
    autoclose: true,
  };
  userProfileDateFields.map(id => $(id).datepicker(datepickerOptions));

  const dropdowns = document.getElementsByClassName('choice-dropdown');
  for (let i = 0; i < dropdowns.length; i++) {
    new Choices(dropdowns[i], {
      searchEnabled: false,
      shouldSort: false,
      itemSelectText: '',
      classNames: {
        containerOuter: 'choices dropdown',
      }
    });
  }
})(window.jQuery);
